export class usersDomainConstants {
    static readonly DOMAIN_USER = '/domain-whitelist/users';
    static readonly DOMAINUSER_ACTION ='/whitelistdomains';
    static readonly DOMAINUSER_DIRECTION ='direction=next';
    static readonly SLASH ='/';
    static readonly QNS_MARK ='?';
    static readonly SEARCH_BY ='searchby=';
    static readonly DELETE_BY ='emailDomains=';
    static readonly SORTBY = '&sortby=';
    static readonly SORT_TYPE = '&sorttype=';
    static readonly SORTBY_DESC = "desc";
    static readonly SORTBY_CRD_TIME = 'createdtime';
    static readonly PAGE_NUMBER = '?pagenumber';
    static readonly EQUALS = '=';
    static readonly EMAIL_SORT = 'emaildomain';
}